export function getAppScrollElement(): HTMLElement | null {
    if (typeof document === "undefined") return null;
    return document.scrollingElement as HTMLElement | null;
}

export function getPageScrollElement(): HTMLElement | null {
    if (typeof document === "undefined") return null;
    return document.scrollingElement as HTMLElement | null;
}

export function getPageScrollTop(): number {
    if (typeof window === "undefined") return 0;
    return window.scrollY;
}

export function addPageScrollListener(handler: () => void): () => void {
    if (typeof window === "undefined") return () => {};

    function onScroll(event: Event) {
        const target = event.target;
        const isPageScroller =
            target === document ||
            target === document.documentElement ||
            target === document.body;
        if (isPageScroller) handler();
    }

    window.addEventListener("scroll", onScroll, {
        passive: true,
        capture: true,
    });
    window.addEventListener("resize", handler, { passive: true });
    return () => {
        window.removeEventListener("scroll", onScroll, { capture: true });
        window.removeEventListener("resize", handler);
    };
}
